import axios from "../../../helper/legalAxios";
import { clearLegalDocs, getLegalDocList, removeLegalDoc } from "./legalSlice";

export const fetchLegalDocs = (params) => async (dispatch) => {
  // To fetch all the document list on the basis of organisation id
  dispatch(clearLegalDocs());
  return axios
    .post("/search-document", { ...params })
    .then((response) => {
      if (response?.data?.success) {
        dispatch(getLegalDocList(response?.data?.data));
      }
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteLegalDoc = (param) => async (dispatch) => {
  // To delete a document
  return axios
    .post("/delete-document", param)
    .then((response) => {
      if (response && response?.data && response?.data?.success) {
        dispatch(removeLegalDoc(param));
      }
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const uploadLegalDoc = (param) => async (dispatch) => {
  // To create a new document
  return axios
    .post("/create-document", param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateLegalDoc = (param) => async (dispatch) => {
  // To update a document
  return axios
    .post("/update-document", param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getDocumentDetails = (param) => async (dispatch) => {
  // To fetch single document details
  return axios
    .post("/get-document-details", param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const signDocument = (param) => async (dispatch) => {
  // To sign the document
  return axios
    .post("/save-user-document", param)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
